import request from '../utils/request';
import baseApi from './baseApi';

export function getScales(uuid, params, signal) {
  return request({
    url: `/restaurants/${uuid}/scales`,
    method: 'get',
    signal,
    data: params,
  });
}

export function updateScales(uuid, params) {
  return request({
    url: `/restaurants/${uuid}/scales`,
    method: 'put',
    data: params,
  });
}

export function getRules(params, signal) {
  return request({
    url: `/adjustmentRules`,
    method: 'get',
    signal,
    data: params,
  });
}

export function addRule(data) {
  return request({
    url: `/adjustmentRules`,
    method: 'post',
    data,
  });
}

export function updateRule(uuid, data) {
  return request({
    url: `/adjustmentRules/${uuid}`,
    method: 'put',
    data,
  });
}

export function deleteRule(uuid) {
  return request({
    url: `/adjustmentRules/${uuid}`,
    method: 'delete',
  });
}

export function getRulesVersions(params) {
  return request({
    url: `/adjustmentRules/versions`,
    method: 'get',
    data: params,
  });
}

export function getRuleVersion(uuid) {
  return request({
    url: `/adjustmentRules/versions/${uuid}`,
    method: 'get',
  });
}

export function restoreRuleVersion(uuid) {
  return request({
    url: `/adjustmentRules/versions/${uuid}/restore`,
    method: 'post',
  });
}

export function deleteRuleVersion(uuid) {
  return request({
    url: `/adjustmentRules/versions/${uuid}`,
    method: 'delete',
  });
}

export function getRecommendationAlgorithmSettings(uuid, params, signal) {
  return request({
    url: `/restaurants/${uuid}/recommendation-algorithms`,
    method: 'get',
    data: params,
    signal,
  });
}

export function updateRecommendationAlgorithm(restaurantUuid, uuid, data) {
  return request({
    url: `/restaurants/${restaurantUuid}/recommendation-algorithms/${uuid}`,
    method: 'put',
    data,
  });
}

export const adjustmentApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    enableRule: builder.mutation({
      query: ({ uuid, enabled }) => ({
        url: `/adjustmentRules/${uuid}/enabled`,
        method: 'PATCH',
        data: { enabled },
      }),
    }),
    updateRules: builder.mutation({
      query: ({ restaurantUuid, data }) => ({
        url: `/adjustmentRules/bulk/${restaurantUuid}`,
        method: 'PUT',
        data,
      }),
    }),
  }),
});

export const { useEnableRuleMutation: useEnableRule, useUpdateRulesMutation: useUpdateRules } = adjustmentApi;

export default adjustmentApi;
